import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ProjectionComponent } from './projection.component';

@NgModule({
  imports: [CommonModule, PipesModule],
  declarations: [ProjectionComponent],
  exports: [ProjectionComponent],
})
export class ProjectionModule {}
